<script>
  import Icon from "svelte-awesome";
  import { Badge, Spinner } from "sveltestrap";
  import { tasks, comment } from "svelte-awesome/icons";
  import JobsCardContainer from "./JobsCardContainer.svelte";
  import { onMount, createEventDispatcher, setContext } from "svelte";
  import axios from "axios";

  export let deliverableItem = {};
  export let jobCards = [];

  let filteredJobCards = [];

  let dispatch = createEventDispatcher();

  const formOptions = {
    allowStatusEditing: deliverableItem.AllowStatusEditing
  };
  setContext('formOptions', formOptions);

  onMount(() => {
    filteredJobCards = jobCards.filter(e => e.DeliverableItemId === deliverableItem.DeliverableItemId);
  });

  function saveXmlUserSettings(deliverableItemId)
  {
    var productions = document.getElementById("filterDeliverable").value;
    productions = productions.replace(deliverableItemId,"")
     axios
      .get("/xmlapi/SaveFilterJobBoard?filter="+productions)
      .then(function(response) {
        hide = !hide;
        document.getElementById("filterDeliverable").value = productions;
        document.getElementById("clickedFilter").click();
        deliverable.HideDeliverable = true;
      })
      .catch(function(error) {
        console.log(error);
      });

  }

  function onHideClicked() {
    dispatch('hide', deliverableItem.DeliverableItemId);
  }

</script>

<style>
    .deliverable-container {
      min-width: 181px;
      max-width: 181px;
      margin: 0 1px;
    }
    .deliverable-header-container { position: sticky; position: -webkit-sticky; top: 0; height: max-content; }
    .deliverable-header {
      font-size: 12px;
      position: absolute;
      min-width: 181px;
      max-width: 181px;
      left: 1px;
      background-color: #223646;
      color: #fff;
      border-radius: 0;
      display: table;
      width: 100%;
      height: 53px;
      text-align: center;
      padding: 10px 20px 10px 10px;
      border: 1px solid #071b2b;
      line-height: 13px
    }
    .deliverable-header span {
      display: table-cell;
      vertical-align: middle;
    }
    .deliverable-content {
      margin-top: 56px;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    .deliverable-btn{
      position: absolute;
      border: none;
      background-color: transparent;
      font-size: 12px;
      right: 6px;
      color: #fff;
      right: 6px;
      top: 16px;
    }
   /* @media (max-width: 768px) {
    .deliverable-header-container {position:relative}
    .deliverable-header {
      width: 97%;
      font-size: 12px;
      font-weight: 600;
      border: 1px solid #ced4da;
      border-radius: 0;
      min-height: auto;
      position:relative;
    }
    .deliverable-content{
      margin-top: 10px;
      background-color: transparent;
      padding: 0;
    }
    .deliverable-container {
      width: 100%;
      max-width: 100%;
    }
	}*/

  .compact.deliverable-container,
  .compact.deliverable-header {
    min-width: 221px;
    max-width: 221px;
  }
</style>

<div class="deliverable-header-container">
  <div class="deliverable-header compact">
    <span>{deliverableItem.Name}</span>
    <button class="deliverable-btn" on:click={onHideClicked}> x </button>
  </div>
</div>
<div class="deliverable-container compact" id={deliverableItem.DeliverableItemName}>
<div class="deliverable-content">
  {#if filteredJobCards.length == 0}
    <center>
      <div>No data</div>
    </center>
  {:else}
    {#each filteredJobCards as jobCard}
      <JobsCardContainer
        jobDetail={jobCard}
        deliverableItemId={deliverableItem.DeliverableItemId}
        deliverableItemSequenceNo={deliverableItem.SequenceNumber}
        on:jobUpdated />
    {/each}
  {/if}
  </div>
</div>
